import React from 'react';
import CheckOrCross from '../Shared/CheckOrCross';

const FEATURE_NAME = 'ai-rewrite';

const aiRewriteFeatures = ({ packages }) => ({
  costPerCharacter: {
    key: 'ai-rewrite-cost-per-char',
    label: 'aiRewriteText',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(FEATURE_NAME)}
      />
    )),
  },
});

export default aiRewriteFeatures;
